// extracted by mini-css-extract-plugin
export default {"root":"Main_root__sbarJ","table":"Main_table__Gb2wx"};